import angular from 'angular';
import classNames from 'classnames';
import { getRelationIconClass } from '@/shared/components/RelationTypeIcon';

angular.module('cloudX').component('cxRelationIcon', {
  template: `<i ng-class="$ctrl.iconClass"></i>`,
  bindings: {
    type: '<',
    crm: '<?',
    active: '<?',
    iclass: '@?',
  },
  controller: [
    function() {
      const ctrl = this;
      ctrl.$onChanges = function() {
        ctrl.iconClass = classNames(
          getRelationIconClass(ctrl.type, ctrl.crm, ctrl.active),
          ctrl.iclass,
        );
      };
    },
  ],
});
